export default __webpack_public_path__ + "5480ed23b199531a8cbc05924f26952b.png";